exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#customers[data-v-4591a0cc]{font-family:Trebuchet MS,Arial,Helvetica,sans-serif;border-collapse:collapse;width:100%}#customers td[data-v-4591a0cc],#customers th[data-v-4591a0cc]{border:2px solid #ddd;padding:8px;text-align:left;width:1%;white-space:nowrap}#customers tr[data-v-4591a0cc]:nth-child(2n){background-color:#f2f2f2}#customers tr[data-v-4591a0cc]:hover{background-color:#ddd}#customers th[data-v-4591a0cc]{padding-top:12px;padding-bottom:12px;text-align:left;background-color:#38863b;color:#fff}#auto[data-v-4591a0cc]{overflow-x:auto;width:100%}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-4591a0cc","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/procurement/package/step_forms/stepDateEntry.vue
// module id = 1381
// module chunks = 3